import React from 'react';
export default function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  return /*#__PURE__*/React.createElement(React.Fragment, null, breadcrumbs && breadcrumbs.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb-wrapper main-container flex-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb-layer flex-box flex-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb flex-box flex-wrap items-center"
  }, breadcrumbs.map(function (breadcrumb, index) {
    if (breadcrumb) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "breadcrumb-item"
      }, breadcrumb.href !== null ? /*#__PURE__*/React.createElement("a", {
        rel: "nofollow noindex noreferrer",
        href: breadcrumb.href
      }, breadcrumb.title) : /*#__PURE__*/React.createElement("span", null, breadcrumb.title), !breadcrumb.last && /*#__PURE__*/React.createElement("i", {
        className: "right_icon"
      }));
    } else {
      return null;
    }
  }))))));
}